import * as actionTypes from './actionTypes';
import axios from 'axios';

export const setProducts = (products) => {
    return {
        type: actionTypes.SET_PRODUCTS,
        products: products
    }
}

export const setTemplates = (templates) => {
    return {
        type: actionTypes.SET_TEMPLATES,
        templates: templates
    }
}

export const setTemplatesProducts = (m2quantities,templateID) => {
    return {
        type: actionTypes.SET_TEMPLATEPRODUCTS,
        m2quantities: m2quantities,
        templateID:templateID
    }
}

export const setAlternativeOptions = (alternativeOptions) => {
    return {
        type: actionTypes.SET_ALTERNATIVEOPTIONS,
        alternativeOptions: alternativeOptions
    }
}

export const setAlternativeOptionsTemplate = (alternativeOptionsTemplate) => {
    return {
        type: actionTypes.SET_ALTERNATIVEOPTIONSTEMPlATE,
        alternativeOptionsTemplate: alternativeOptionsTemplate
    }
}


export const loadProducts = () => {
    return dispatch => {
        axios.get('http://190.105.227.203/knauf/products/')
        .then ( response => {
            dispatch(setProducts(response.data));
        })
        .catch(error => {
            
        })
    }
}

export const loadTemplates = (caculatorID) => {
    return dispatch => {
        axios.get('http://190.105.227.203/knauf/templates/'+caculatorID)
        .then ( response => {
            dispatch(setTemplates(response.data));
        })
        .catch(error => {
            
        }).finally(function() {
            dispatch(loadAlternativeOptions(caculatorID));
        })
    }
}

export const loadTemplateProducts = (templateID) => {
    return dispatch => {
        axios.get('http://190.105.227.203/knauf/m2quantities/'+(parseInt(templateID)+1))
        .then ( response => {
            dispatch(setTemplatesProducts(response.data,templateID));
        })
        .catch(error => {
            
        })
    }
}

export const loadAlternativeOptions = (calculatorID) => {
    return dispatch => {
        axios.get('http://190.105.227.203/knauf/alternativeOptions/'+calculatorID)
        .then ( response => {
            dispatch(setAlternativeOptions(response.data));
        })
        .catch(error => {
            
        })
    }
}

export const loadAlternativeOptionsTemplate = (templateID) => {
    return dispatch => {
        axios.get('http://190.105.227.203/knauf/alternativeOptionsTemplate/'+(parseInt(templateID)+1))
        .then ( response => {
            dispatch(setAlternativeOptionsTemplate(response.data));
        })
        .catch(error => {
            
        })
    }
}